import { useState } from "react";
import { Link, useLocation } from "wouter";
import { Menu, Music } from "lucide-react";
import { Button } from "@/components/ui/button";
import MobileMenu from "./mobile-menu";
import { ThemeToggle } from "@/components/ui/theme-toggle";

export default function Header() {
  const [location] = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const isActive = (path: string) => location === path;

  return (
    <header className="bg-background border-b border-border sticky top-0 z-50">
      <div className="container mx-auto px-4 py-4 grid grid-cols-3 items-center">
        <div className="col-span-1">
          <Link href="/" className="flex items-center space-x-2">
            <div className="w-10 h-10 rounded-full bg-primary flex items-center justify-center text-black dark:text-white">
              <Music className="h-5 w-5" />
            </div>
            <span className="text-xl font-bold font-heading text-primary">NoLicense Nearby</span>
          </Link>
        </div>
        
        <nav className="hidden md:block col-span-1 mx-auto">
          <ul className="flex space-x-8">
            <li>
              <Link href="/catalog">
                <span className={`font-medium cursor-pointer ${isActive('/catalog') ? 'text-primary' : 'text-foreground hover:text-primary'}`}>
                  Catalog
                </span>
              </Link>
            </li>
            <li>
              <Link href="/pricing">
                <span className={`font-medium cursor-pointer ${isActive('/pricing') ? 'text-primary' : 'text-foreground hover:text-primary'}`}>
                  Pricing
                </span>
              </Link>
            </li>
            <li>
              <Link href="/license">
                <span className={`font-medium cursor-pointer ${isActive('/license') ? 'text-primary' : 'text-foreground hover:text-primary'}`}>
                  License Music
                </span>
              </Link>
            </li>
            <li>
              <Link href="/about">
                <span className={`font-medium cursor-pointer ${isActive('/about') ? 'text-primary' : 'text-foreground hover:text-primary'}`}>
                  About
                </span>
              </Link>
            </li>
          </ul>
        </nav>
        
        <div className="col-span-1 flex items-center justify-end space-x-4">
          <ThemeToggle />
          
          <Link href="/license">
            <Button 
              className="hidden md:inline-flex bg-primary text-black dark:text-white hover:opacity-90"
            >
              License Music
            </Button>
          </Link>
          
          <Button 
            variant="ghost" 
            size="icon" 
            className="md:hidden"
            onClick={() => setMobileMenuOpen(true)}
          >
            <Menu className="h-6 w-6" />
          </Button>
        </div>
      </div>
      
      <MobileMenu isOpen={mobileMenuOpen} onClose={() => setMobileMenuOpen(false)} />
    </header>
  );
}
